export default __webpack_public_path__ + "static/media/browse-car.300b512f.png";